import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/69eac09463911b0014dc1591_1786234776661_323609ac/vidstar/src/app/blog/page.tsx");
